import { useEffect, useMemo, useSyncExternalStore, type ReactElement } from 'react';
import { creerClient } from '../../api/client.js';
import type { Ecran } from '../../api/contrat.js';
import { COULEURS } from '../../app/styles.js';
import { creerControleur } from './controleur.js';
import { FicheHeritier } from './FicheHeritier.js';
import { creerSource } from './source.js';

/**
 * La fiche s'ouvre depuis le dossier avec `?personne=<id>&dossier=<id>`. Sans ces deux paramètres, l'écran invite à
 * choisir une fiche (aucun héritier n'est jamais deviné).
 */
export function selectionDepuisAdresse(recherche: string): { personId: string; dossierId: string } | null {
  const parametres = new URLSearchParams(recherche);
  const personId = parametres.get('personne');
  const dossierId = parametres.get('dossier');
  return personId && dossierId ? { personId, dossierId } : null;
}

const adresseCourante = (): string => (typeof window === 'undefined' ? '' : window.location.search);

/** D05 · Fiche héritier : l'écran branché dans le registre de la coquille. */
export function EcranFicheHeritier({ ecran }: { ecran: Ecran }): ReactElement {
  const controleur = useMemo(
    () =>
      creerControleur(
        creerSource(creerClient({ fetch: (...args) => globalThis.fetch(...args) })),
        selectionDepuisAdresse(adresseCourante()),
      ),
    [],
  );
  useEffect(() => {
    void controleur.charger();
  }, [controleur]);
  const etat = useSyncExternalStore(controleur.abonner, controleur.etat, controleur.etat);
  return (
    <section data-ecran={ecran.id} data-composant="fiche-heritier">
      <h1 style={{ color: COULEURS.marine, fontSize: 28 }}>{ecran.titre}</h1>
      {etat.statut === 'chargement' ? <p role="status">Chargement de la fiche en cours…</p> : null}
      {etat.statut !== 'pret' && etat.message ? <p role="status">{etat.message}</p> : null}
      {etat.statut === 'pret' && etat.donnees ? <FicheHeritier donnees={etat.donnees} vue={etat.vue} actions={controleur.actions} /> : null}
    </section>
  );
}
